import React, { useContext, useMemo, useState } from 'react';
import HeaderPreview from '../../../GeneratePdf/HeaderPreview';
import FooterPreview from '../../../GeneratePdf/FooterPreview';
import GroupReportContext from '../../../../Context/GroupReportContext';
import { initialDataLeaderShip } from './QuadrantInFocus';

const styles = {
  container: { paddingTop: '16px' },
  heading: { fontSize: "14px", paddingBottom: "16px", lineHeight: "18px", fontWeight: 700, color: "#426B88", margin: 0, fontFamily: "'Helvetica', sans-serif", letterSpacing: 0 },
  description: { marginBottom: "16px", color: "#000000", marginTop: 0, fontFamily: "'Helvetica', sans-serif", fontWeight: 400, fontStyle: 'normal', fontSize: '10px', lineHeight: '14px', letterSpacing: '0px' }, tableWrapper: { overflow: "hidden", border: "0.25px solid #0000001A", borderRadius: "10px" },
  tableWrapper: { overflow: "hidden", border: "0.25px solid #0000001A", borderRadius: "10px" },
  table: { width: "100%", borderCollapse: "separate", borderSpacing: "0", lineHeight: "13px", },
  th: { padding: "0 12px", backgroundColor: "#245775", color: "white", textAlign: "center", fontFamily: 'Helvetica', fontWeight: 400, lineHeight: "13px", fontStyle: 'normal', fontSize: '9px', letterSpacing: '0px' },
  td: { borderLeft: "0.65px solid #0000001A", padding: "5px", textAlign: "center", fontFamily: 'Helvetica', fontWeight: 400, fontStyle: 'normal', fontSize: '9px', letterSpacing: '0px', color: "#000000" },
  visionaryColumn: { width: "100%", textAlign: "left", padding: "5.5px 15px", border: "none" },
  rowEven: { backgroundColor: "#FFF" },
  rowOdd: { backgroundColor: "#F1F3F3" },
  rectangleWrapper: { display: "flex", justifyContent: "center", alignItems: "center", height: "26px", width: "25px", margin: "0 auto" },
  rectangle: { width: "16px", height: "16px", backgroundColor: "#00577D", borderRadius: "1.34px" }
};

export default function VisionaryGroupPreview({ apiData, previewData, reportType, pageNumber }) {
  // console.log('VisionaryGroupPreview apiData:', apiData);
  // console.log('VisionaryGroupPreview previewData:', previewData);

  const [dynamicData, setDynamicData] = useState([...initialDataLeaderShip]);
  const groupReportCtx = useContext(GroupReportContext)

  const renderRectangle = (avgScore, index) => {
    const full = Math.floor(avgScore);
    const partial = avgScore - full;
    if (index + 1 < full + 1) {
      // Full square
      return <div style={styles.rectangle}></div>;
    } else if (index === full && partial > 0) {
      // Partial square (only red part, no light background)
      return (
        <div style={{ ...styles.rectangle, position: 'relative', overflow: 'hidden', backgroundColor: 'transparent' }}>
          <div style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: `${partial * 100}%`,
            height: '100%',
            backgroundColor: '#00577D',
            borderRadius: '1.34px',
            zIndex: 2,
          }}></div>
        </div>
      );
    } else {
      return null;
    }
  };

  const questions = [
    { id: 1, question: "When leading through conflict, I can envision how this particular circumstance fits within a larger story." },
    { id: 2, question: "I am at my best when casting a vision of where we should be heading." },
    { id: 3, question: "I believe stories help communicate the core values of an organization." },
    { id: 4, question: "I am always looking to place a particular project within the context of the larger purpose." },
    { id: 5, question: "I believe sharing inspirational stories should be an important part of a company's culture." },
    { id: 6, question: "I am motivated by creativity." },
    { id: 7, question: "I believe success is contingent on having a clear vision." },
    { id: 8, question: `I develop others by helping them see the “why” behind the work.` },
    { id: 9, question: "I can weave a powerful narrative that unites people for a common purpose." },
    { id: 10, question: "I can usually see what lies ahead in the future of our organization." }
  ];

  // Show only items 21-40 (index 20 onwards)
  const displayData = dynamicData?.filter((el) => el.quadrant == "VISIONARY");
  const allVariableSets = Array.isArray(apiData?.results) ? apiData.results.map((el) => el.variables) : [];

  const quadrantScores = {
    "PERFORMANCE": 1,
    "STRATEGIC": 2,
    "VISIONARY": 3,
    "COLLABORATIVE": 4
  }
  const allResults = [];
  displayData?.forEach((el, index) => {
    // console.log(el.quadrant, quadrantScores?.[el.quadrant])
    const res = groupReportCtx?.calculateQuestionScoreLeadership(quadrantScores?.[el.quadrant], allVariableSets, index + 1, "in_focus");
    if (res?.averageScore !== null && quadrantScores?.[el.quadrant] == 3) {
      allResults.push(res);
    }
  })

  // console.log("allResults", allResults)

  return (
    <div>
      <HeaderPreview />
      <div style={styles.container}>
        <h1 style={styles.heading}>VISIONARY LEADERSHIP IN FOCUS</h1>
        <p style={styles.description}>
          This chart isolates the items related to Visionary Leadership based on the combined ratings of participants. The response scale runs from 1 (Least) to 4 (Most). Any unselected statement will appear blank in the In Focus section.
        </p>

        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={{ ...styles.th, ...styles.visionaryColumn }}>Visionary</th>
                <th style={{ ...styles.th }}>Score</th>
                {[1, 2, 3, 4].map((num) => (
                  <th key={num} style={styles.th}>
                    {num}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {questions.map((item, index) => {
                const avgScore = allResults[index]?.averageScore;
                return (
                  <tr
                    key={index}
                    style={(index % 2) === 0 ? styles.rowOdd : styles.rowEven}
                  >
                    <td style={{ ...styles.td, ...styles.visionaryColumn }}>
                      {item.question}
                    </td>
                    <td style={{ ...styles.td }}> {parseFloat(avgScore) > 0 ? avgScore : "-"} </td>
                    {[0, 1, 2, 3].map((idx) => (
                      <td key={idx} style={styles.td}>
                        <div style={styles.rectangleWrapper}>
                          {renderRectangle(avgScore, idx)}
                        </div>
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
}
